// @flow

import React from "react";
import { localize } from "redux-i18n";

import { GSGrid } from "@components";

import type {
  AbsenceReasonReportData,
  AbsenceReasonReport,
} from "@modules/reporting/reducer/trends/absence-reason/types";
import { currencyTransform } from "@transformers/string";
import { PERCENTAGE } from "@modules/reporting/constants/reports";

type OwnProps = $Exact<{
  reportData: AbsenceReasonReportData,
  onClickAbsenceProfile: (absenceReasonId: number) => void,
  reportDetails?: AbsenceReasonReport,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export const TrendAbsenceReasonReportTable = (props: Props) => {
  const trendType = ((props.reportDetails || {}).filters || {}).trendType;
  const showCurrency = trendType && trendType === "COST_OF_ABSENCE";

  const handleOnClickAbsenceProfile = (row: *) => () => {
    props.onClickAbsenceProfile(row.id);
  };
  return (
    <div className="w-100 trend-absence-reason-report-table">
      {props.reportData.details[0] && (
        <GSGrid
          rows={props.reportData.details.map(row => {
            return { ...row, key: row.name };
          })}
          columns={[
            {
              name: props.t("REASON"),
              key: "name",

              align: "left",
              frozen: "left",
            },
            ...(props.reportData.details[0]
              ? (props.reportData.details[0].periods || []).map((period, idx) => ({
                  ...period,
                  name: period.key,
                  key: period.key,

                  width: 80,
                  align: "center",
                  headerCellClass: "fs-12",
                  cellClass: "p-1px",
                  renderCell: ({ row, column }: *) => {
                    const cellData = row.periods.find((r: Object) => {
                      return r.key === column.name;
                    });
                    if (!cellData) return null;
                    const { value, delta } = cellData;
                    return GSGrid.render.deltaArrowTrendIndicator(
                      showCurrency ? currencyTransform(value) : value,
                      delta,
                    );
                  },
                }))
              : []),
            {
              name: props.t("TOTAL"),
              key: "total",
              cellClass: "p-1px",
              width: 100,
              frozen: "right",
              renderCell: ({ row }: *) => {
                const { total, max, percentage, periods } = row || {};
                const totalCurrency = {
                  total: showCurrency ? currencyTransform(total) : total,
                  max: showCurrency ? currencyTransform(max) : max,
                };
                const isPercentage = periods.some(item => item.type === PERCENTAGE);
                return GSGrid.render.barIndicator({
                  total: isPercentage ? `${percentage}%` : totalCurrency.total,
                  max: totalCurrency.max,
                });
              },
            },
            {
              name: props.t("TREND"),
              key: "trend",
              cellClass: "p-1px",
              width: 100,
              frozen: "right",
              renderCell: ({ row }: { row: Object }) => {
                return GSGrid.render.sparklineIndicator({ rowHeight: 40, periods: row.periods });
              },
            },
            {
              width: 50,
              frozen: "right",
              key: "handleOnClickAbsenceProfile",
              renderCell: ({ row }: { row: Object }) => (
                <div
                  onClick={handleOnClickAbsenceProfile(row)}
                  className="cursor-pointer material-icons fs-34"
                >
                  insert_chart
                </div>
              ),
            },
          ]}
        />
      )}
    </div>
  );
};

export default localize()(TrendAbsenceReasonReportTable);
